export enum StrikesColoringMethod {
    Classic,
    HistoricalVolatility
}
